import React from 'react';
import useIsMobile from '../../../hooks/useIsMobile';
import { ReactComponent as MapIcon } from "../../../assets/icons/map-02.svg";
import { ReactComponent as GlobeIcon } from "../../../assets/icons/globe-02.svg";

interface MapStyleToggleProps {
  mapStyle: string;
  onStyleChange: (style: string) => void;
}

/**
 * A component for toggling between different map styles (light and satellite)
 */
const MapStyleToggle: React.FC<MapStyleToggleProps> = ({ mapStyle, onStyleChange }) => {
  const isMobile = useIsMobile();
  
  const LIGHT_STYLE = "mapbox://styles/mapbox/light-v9";
  const SATELLITE_STYLE = "mapbox://styles/mapbox/satellite-streets-v12";

  return isMobile ? (
    <div style={{position: 'absolute', top: '4px', right: '5px', zIndex: 10}}>
      <div className="flex bg-white rounded-md shadow-lg overflow-hidden border border-gray-200">
        <button
          className={`p-2 ${mapStyle === LIGHT_STYLE ? "bg-gray-200" : "bg-white hover:bg-gray-100"}`}
          onClick={() => onStyleChange(LIGHT_STYLE)}
          title="Map View"
        >
          <MapIcon className="w-5 h-5" />
        </button>
        <button
          className={`p-2 ${mapStyle === SATELLITE_STYLE ? "bg-gray-200" : "bg-white hover:bg-gray-100"}`}
          onClick={() => onStyleChange(SATELLITE_STYLE)}
          title="Satellite View"
        >
          <GlobeIcon className="w-5 h-5" />
        </button>
      </div>
    </div>
  ) : (
    <div className="absolute top-1 right-1 z-10">
      <div className="flex bg-white rounded-md overflow-hidden border border-gray-200">
        <button
          className={`p-1 ${mapStyle === LIGHT_STYLE ? "bg-gray-200" : "bg-white hover:bg-gray-100"}`}
          onClick={() => onStyleChange(LIGHT_STYLE)}
          title="Map View"
        >
          <MapIcon className="w-6 h-6" />
        </button>
        <button
          className={`p-1 ${mapStyle === SATELLITE_STYLE ? "bg-gray-200" : "bg-white hover:bg-gray-100"}`}
          onClick={() => onStyleChange(SATELLITE_STYLE)}
          title="Satellite View"
        >
          <GlobeIcon className="w-6 h-6" />
        </button>
      </div>
    </div>
  );
};

export default MapStyleToggle;